/**
 * Formatage intelligent des horodatages de message :
 * - moins de 24h : heure seule ("11h13")
 * - moins de 7 jours : jour abrégé + heure ("jeu. 11h13")
 * - au-delà : date complète + heure ("28.08.26 12h34")
 * Construction manuelle (pas de toLocaleTimeString) car le séparateur "h" n'est pas garanti par Intl.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function timeHm(date: Date): string {
  return `${pad(date.getHours())}h${pad(date.getMinutes())}`;
}

export function formatMessageDate(iso: string): string {
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();

  if (diffMs < DAY_MS) {
    return timeHm(date);
  }
  if (diffMs < 7 * DAY_MS) {
    const weekday = date.toLocaleDateString('fr-FR', { weekday: 'short' });
    return `${weekday} ${timeHm(date)}`;
  }
  const dmy = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${String(date.getFullYear()).slice(-2)}`;
  return `${dmy} ${timeHm(date)}`;
}
